import { getApp } from "firebase/app";
import { getFunctions, httpsCallable } from "firebase/functions";
import type { EventMemberRole } from "../collections/eventUsers";
import type { AccountUserRole } from "../collections/accountUsers";

export type PendingAccountInvitation = {
  accountId: string;
  invitationId: string;
  role: AccountUserRole;
  accountName?: string;
  inviterName?: string;
};

export type PendingEventInvitation = {
  accountId: string;
  eventId: string;
  invitationId: string;
  role: EventMemberRole;
  accountName?: string;
  eventName?: string;
  inviterName?: string;
};

type AccountInvitationParams = {
  accountId: string;
  invitationId: string;
};

type EventInvitationParams = {
  accountId: string;
  eventId: string;
  invitationId: string;
};

export async function getMyPendingAccountInvitations(): Promise<
  PendingAccountInvitation[]
> {
  const functions = getFunctions(getApp());
  const callable = httpsCallable<undefined, PendingAccountInvitation[]>(
    functions,
    "getMyPendingAccountInvitations"
  );
  const result = await callable();
  return result.data ?? [];
}

export async function getMyPendingEventInvitations(): Promise<
  PendingEventInvitation[]
> {
  const functions = getFunctions(getApp());
  const callable = httpsCallable<undefined, PendingEventInvitation[]>(
    functions,
    "getMyPendingEventInvitations"
  );
  const result = await callable();
  return result.data ?? [];
}

export async function acceptAccountInvitation(
  accountId: string,
  invitationId: string
): Promise<void> {
  const functions = getFunctions(getApp());
  const callable = httpsCallable<AccountInvitationParams, { ok: boolean }>(
    functions,
    "acceptAccountInvitation"
  );
  await callable({ accountId, invitationId });
}

export async function acceptEventInvitation(
  accountId: string,
  eventId: string,
  invitationId: string
): Promise<void> {
  const functions = getFunctions(getApp());
  const callable = httpsCallable<EventInvitationParams, { ok: boolean }>(
    functions,
    "acceptEventInvitation"
  );
  await callable({ accountId, eventId, invitationId });
}
